export default __webpack_public_path__ + "static/media/user-cog.de0d0669.svg";